export var DataCatalogTagOperator;
(function (DataCatalogTagOperator) {
    DataCatalogTagOperator["DATA_CATALOG_TAG_OPERATOR_IN"] = "IN";
    DataCatalogTagOperator["DATA_CATALOG_TAG_OPERATOR_EXISTS"] = "EXISTS";
})(DataCatalogTagOperator || (DataCatalogTagOperator = {}));
